import React from 'react';
import { observer } from '../../shared/observer';

// Счётчик «Бутылей к обмену». Аналог:
// client_app/src/screens/Cart/CartList/ShoppingCart/RecycledTareReturnPromise/index.tsx
//
// Видимость гейтится родителем (см. CartApp). Здесь компонент только
// читает `cart.need_coupled_count` и зовёт `changeNeedCoupledCount`
// (стор сам оптимистично мутирует значение и debounce-шлёт на сервер).
class RecycledTareReturnPromiseView extends React.Component {
  inc = () => {
    const cart = this.props.cart;
    cart.changeNeedCoupledCount((cart.cart.need_coupled_count || 0) + 1);
  };

  dec = () => {
    const cart = this.props.cart;
    const cur = cart.cart.need_coupled_count || 0;
    if (cur <= 0) return;
    cart.changeNeedCoupledCount(cur - 1);
  };

  render() {
    const cart = this.props.cart;
    const auth = this.props.auth;
    const value = cart.cart.need_coupled_count || 0;
    const tare = (auth.companyInfo.cart_coupled) || {};
    const label = tare.return_bottles_txt || 'Бутылей к обмену';

    return (
      <div className="ng-recycled-tare__promise">
        <span className="ng-recycled-tare__promise-label">{label}</span>
        <span className="item-show-price-incart__wrapper">
          <a href="#" className="down" onClick={(e) => { e.preventDefault(); this.dec(); }}>−</a>
          <span className="item-show-price-incart__count">{value}</span>
          <a href="#" className="up" onClick={(e) => { e.preventDefault(); this.inc(); }}>+</a>
        </span>
      </div>
    );
  }
}

export const RecycledTareReturnPromise = observer(RecycledTareReturnPromiseView, ['cartStore', 'authStore']);



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/components/Cart/RecycledTareReturnPromise.jsx